import { MomentumModalV4 } from "@circle-react-shared/ModalsV2/MomentumModalV4";

import { useCircleV4 } from "@/react/hooks/useCircleV4";

import type { MomentumModalProps } from "./MomentumModalUIKit";
import { MomentumModalUIKit } from "./MomentumModalUIKit";

export type { MomentumModalProps } from "./MomentumModalUIKit";

export function MomentumModal(props: MomentumModalProps) {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    const {
      title,
      description,
      onClose,
      children,
      isLoading,
      isOpen,
      multiCTASectionLayout: isMultiCTASectionLayout,
    } = props;
    return (
      <MomentumModalV4
        title={title}
        description={description}
        onClose={onClose}
        isLoading={isLoading}
        isOpen={isOpen}
        multiCTASectionLayout={isMultiCTASectionLayout}
      >
        {children}
      </MomentumModalV4>
    );
  }

  return <MomentumModalUIKit {...props} />;
}
